import { render, staticRenderFns } from "./Whatsapp.vue?vue&type=template&id=42ae747f&scoped=true&"
import script from "./Whatsapp.vue?vue&type=script&lang=js&"
export * from "./Whatsapp.vue?vue&type=script&lang=js&"
import style1 from "./Whatsapp.vue?vue&type=style&index=1&id=42ae747f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ae747f",
  null
  
)

export default component.exports